// Export the singleton and types
export { userAppData, UserAppDataSingleton } from './UserAppData';
export type { UserAppData, UserDataChangeCallback, UserLocationData } from './UserAppData';

// Export the React hooks
export {
  useUserAppData,
  useUserDataInitialized
} from './useUserAppData';

// Export hook types
export type {
  UserAppDataState,
  UserAppDataActions
} from './useUserAppData';

// Export location utilities
export {
  getLocationFromHeaders,
  updateUserLocationFromHeaders,
  getFormattedLocationFromHeaders
} from './location-utils';
